import { render } from "./LogsDatatableTDModelType.vue?vue&type=template&id=0a428e48"
import script from "./LogsDatatableTDModelType.vue?vue&type=script&lang=js"
export * from "./LogsDatatableTDModelType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__